/** View types used across App navigation and MainContent */
export const VIEWS = {
  SPRINT_DETAIL: 'sprint_detail',
  TEMPLATE_DETAIL: 'template_detail',
  DOCS: 'docs',
  DASHBOARDS: 'dashboards',
  SETTINGS: 'settings',
  EMPTY: 'empty',
};
